package team.platforma.multiplatform_material_extension.calendar.utils

import kotlinx.datetime.LocalDate

data class CalendarRange(
    val min: LocalDate,
    val max : LocalDate
)






